var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-body-row",class:{
    odd: _vm.index % 2 === 1,
    even: _vm.index % 2 !== 1
  }},[_vm._l((_vm.colsOrderList),function(originalIndex,columnIndex){return [_c('div',{key:columnIndex,staticClass:"table-body-col",style:({
        width: _vm.colsInfo[originalIndex].calcWidth + 'px'
      }),on:{"click":_vm.onClickRow}},[_vm._l((_vm.colsInfo[originalIndex].items),function(colItem,itemIndex){return [_c('div',{key:itemIndex,staticClass:"table-body-col-item",style:({
            'text-align': colItem.align ? colItem.align : 'left',
            'white-space': colItem.lineFeed ? 'pre-line' : 'nowrap'
          })},[_c('atom-label',[_vm._t(colItem.name,[_vm._v("\n              "+_vm._s(colItem.name === 'no'
                  ? _vm.rowNo
                  : colItem.name === 'descNo'
                  ? _vm.descRowNo
                  : typeof _vm.item === 'string'
                  ? _vm.item
                  : _vm.item[colItem.name])+"\n            ")],{"text":_vm.item[colItem.name]})],2)],1)]})],2)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }